import {createSlice} from "@reduxjs/toolkit";
import {resetPropertiesToDefaultWithExclusions} from "../../utils/ReduxHelper";

export const initialState =
    {
        // Save Validation
        // TODO: each field should have a valid and saved state property instead of simple boolean, however that requires significant refactoring, validation Errors can be used in the interim
        ValidationErrorFields: [],
        Name: false,
        Type: false,
        Category: false,
        Class: false,
        FundingSource: false,
        Unit: false,
        Region: false,
        Agency: false,
        Department: false,
        TribeName: false,
        CongressionalDistrictNumber: false,
        County: false,
        State: false,
        Latitude: false,
        Longitude: false,
        CalculatedArea: false,
        IsWUI: false,
        IsSagebrush: false,
        IsFunded: false,
        IsApproved: false,
        EstimatedSuccessProbability: false,
        Priority: false,
        Durability: false,
        InitiationDate: false,
        InitiationFiscalYear: false,
        InitiationFiscalQuarter: false,
        CompletionDate: false,
        CompletionFiscalYear: false,
        CompletionFiscalQuarter: false,
        EstimatedPersonnelCost: false,
        EstimatedAssetCost: false,
        EstimatedGrantsFixedCost: false,
        EstimatedContractualCost: false,
        EstimatedOtherCost: false,
        EstimatedTotalCost: false,
        LocalApprovalDate: false,
        AgencyApprovalDate: false,
        RegionalApprovalDate: false,
        DepartmentApprovalDate: false,
        UnApprovalDate: false,
        UnApprovalReason: false,
        Notes: false,
        Shape: false,
        Feasibility: false,
        Status: false,
        StatusReason: false,
        FundedDate: false,
        IsPoint: false,
        FundingUnit: false,
        FundingRegion: false,
        FundingAgency: false,
        FundingDepartment: false,
        FundingTribe: false,
        FundingUnitType: false,
        WBSID: false,
        FunctionalArea: false,
        CostCode: false,
        CostCenter: false,
        CancelledDate: false,
        IsBIL: false,
        BilFunding: false,
        HasGroup: false,
        GroupCount: false,
        //hasActual: false,
        UnitID: false,
        VegDeparturePercentageDerived: false,
        VegDeparturePercentageManual: false,
        IsVegetationManual: false,
        FundingSubUnit: false,
        ContributedFundingSource: false,
        ContributedNotes: false,
        ContributedPersonnelCost: false,
        ContributedAssetCost: false,
        ContributedGrantsFixedCost: false,
        ContributedContractualCost: false,
        ContributedOtherCost: false,
        ContributedTotalCost: false,
        ContributedFunctionalArea: false,
        ContributedCostCode: false,
        ContributedCostCenter: false,
        TreatmentDriver: false,
        IsRTRL: false
    }

export const actualsActivityValidationSlice = createSlice({
    name: 'actualsActivityValidation',
    initialState,
    reducers: {
        resetActualsActivityValidationState: (state) => {
            resetPropertiesToDefaultWithExclusions(state, initialState,['ValidationErrorFields'])
        },
        genericActualsActivityValidationFieldSetTrue: (state, action) => {
            if (state[action.payload] === null) {
                return;
            }
            state[action.payload] = true;
        },
        genericActualsActivityValidationFieldSetFalse: (state, action) => {
            if (state[action.payload] === null) {
                return;
            }
            state[action.payload] = false;
        },
        addActualActivityFieldToValidationErrorFields: (state, action) => {
            if (!state.ValidationErrorFields) {
                state.ValidationErrorFields = initialState.ValidationErrorFields;
            }
            if (!state.ValidationErrorFields.includes(action.payload)) {
                state.ValidationErrorFields.push(action.payload);
            }
        },
        removeActualActivityFieldFromValidationErrorFields: (state, action) => {
            state.ValidationErrorFields = state.ValidationErrorFields ? state.ValidationErrorFields.filter(field => field !== action.payload) : initialState.ValidationErrorFields;
        },
        resetActualActivityValidationErrorFields: (state) => {
            state.ValidationErrorFields = [];
        }
    }
});

export const {
    resetActualsActivityValidationState,
    genericActualsActivityValidationFieldSetTrue,
    genericActualsActivityValidationFieldSetFalse,
    addActualActivityFieldToValidationErrorFields,
    removeActualActivityFieldFromValidationErrorFields,
    resetActualActivityValidationErrorFields
} = actualsActivityValidationSlice.actions;

export default actualsActivityValidationSlice.reducer;